import * as React from 'react';

const Stats16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M1.25 10a1.75 1.75 0 1 1 3.5 0v5a.75.75 0 0 1-.75.75H2a.75.75 0 0 1-.75-.75zm5-8a1.75 1.75 0 1 1 3.5 0v13a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75zm5 4a1.75 1.75 0 1 1 3.5 0v9a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1-.75-.75z"
  }
));
Stats16.Size = 16;
Stats16.Title = "Stats";

export { Stats16 as default };
